import { CheckCircleFilled, MinusCircleFilled } from '@ant-design/icons'
import moment from 'moment-timezone'
import {
    ID_ENTERPRISE,
    ID_RESELLER,
} from '@Admin/AdminUserProfilePage/constants'
import { getAllBusinessAccountFeaturesQuery_getAllBusinessAccountFeatures as businessAccountFeature } from '@Admin/BusinessAccountDetailsPage/__generated__/getAllBusinessAccountFeaturesQuery'
import { useDispatch } from 'react-redux'

import Box from '~/core/Box'
import Text from '~/core/Text'
import getColor from '~/lib/getColor'
import Button from '~/core/Button'
import {
    openChatGetPOEnabled,
    openChatGetTaxExempt,
} from '~/redux-modules/drift'

export interface FinancePermissionsSubSectionPropsType {
    financeRole: string
    roleEnabled: boolean
    businessAccountName?: string
    businessAccountFeatures?: businessAccountFeature[]
}

const roleFeatureMap = Object.freeze({
    [ID_ENTERPRISE]: 'po_enabled',
    [ID_RESELLER]: 'tax_exempt',
})

const getRoleEnabledDate = (
    financeRole: string,
    businessAccountFeatures: businessAccountFeature[],
) => {
    if (!businessAccountFeatures.length) {
        return null
    }
    const feature = businessAccountFeatures.find(
        baFeature =>
            baFeature.isEnabled &&
            baFeature.featureName ===
                roleFeatureMap[financeRole as keyof typeof roleFeatureMap],
    )

    return feature ? feature.updatedAt : null
}

export const FinancePermissionsSubSection = (
    props: FinancePermissionsSubSectionPropsType,
) => {
    const {
        financeRole,
        roleEnabled,
        businessAccountName,
        businessAccountFeatures,
    } = props
    let headerText
    let enabledDate
    let permissionRequestText
    let getPermission: (evt: Event) => void
    const dispatch = useDispatch()

    if (financeRole === ID_ENTERPRISE) {
        headerText = 'Pay with PO (Purchase Order)'
        enabledDate = getRoleEnabledDate(
            ID_ENTERPRISE,
            businessAccountFeatures || [],
        )
        permissionRequestText = 'Get PO permissions'
        getPermission = (evt: Event) => {
            evt.preventDefault()
            dispatch(openChatGetPOEnabled())
        }
    } else if (financeRole === ID_RESELLER) {
        headerText = 'Tax-exempt (reseller)'
        enabledDate = getRoleEnabledDate(
            ID_RESELLER,
            businessAccountFeatures || [],
        )
        permissionRequestText = 'Get Tax-exempt permissions'
        getPermission = (evt: Event) => {
            evt.preventDefault()
            dispatch(openChatGetTaxExempt())
        }
    }
    return roleEnabled ? (
        <Box position="relative" flex="1" direction="col">
            <Text fontWeight={500}>{headerText}</Text>
            <Text color="blackAlpha45">
                <CheckCircleFilled
                    style={{
                        color: getColor('success'),
                        marginRight: '5px',
                    }}
                />{' '}
                {enabledDate
                    ? `Enabled under ${businessAccountName} on
                ${moment(enabledDate).format('LL')}`
                    : `Enabled`}
            </Text>
        </Box>
    ) : (
        <Box direction="row" justifyContent="around" alignItems="center">
            <Box position="relative" flex="1" direction="col" marginTop="16px">
                <Text fontWeight={500}>{headerText}</Text>
                <Text color="blackAlpha45">
                    <MinusCircleFilled
                        style={{
                            color: getColor('blackAlpha45'),
                            marginRight: '5px',
                        }}
                    />{' '}
                    Not enabled
                </Text>
            </Box>
            <Button
                onClick={(evt: Event) => {
                    getPermission(evt)
                }}
            >
                {permissionRequestText}
            </Button>
        </Box>
    )
}
